export default __webpack_public_path__ + "static/media/Hamburger_white.9500c029.svg";